import React from 'react';

import { SVGPropsType } from 'src/types';

function HighLowChart(props: SVGPropsType) {
    const { stroke, onClick, style, className } = props;

    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                d="M6.5999 2.40002H2.3999V13.6H6.5999V2.40002Z"
                stroke={stroke}
                strokeWidth="1.2"
                strokeMiterlimit="10"
            />
            <path
                d="M13.5999 5.30005H9.3999V10.6H13.5999V5.30005Z"
                stroke={stroke}
                strokeWidth="1.2"
                strokeMiterlimit="10"
            />
        </svg>
    );
}

export default HighLowChart;
